<div class="d-flex justify-content-between align-items-center mb-3">
  <h5 class="font-medium" id="cryptos">
    {{ 'mydepot.depotoverview.crypto-wallet.headline' | transloco }}
  </h5>
  @if (actionsEnabled) {
    <div class="d-flex align-items-center">
      @if (currentlyEditingEntryQuote) {
        <div class="ml-2 mr-2 text-size-medium border-default p-1 pl-2 pr-2">
          {{ 'mydepot.depotoverview.positions.editable-entry-quotes.label' | transloco }}
        </div>
      }
      @if (currentCustomer) {
        <div class="circle mr-2 cursor-pointer">
          <a
            [href]="environment.apihost + '/api/trading/cryptopositions.csv?customerId=' + currentCustomer.custId"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg class="icon icon-16 text-color-grey">
              <use xlink:href="/assets/img/svgs/svgset.svg#download-redesign-23" />
            </svg>
          </a>
        </div>
      }
      <web-design-system-list-toggle (click)="showPositions = !showPositions" [isCollapsed]="!showPositions" />
    </div>
  }
</div>

@if (cryptoSettings$ | async; as settings) {
  @if (positionsFacade.cryptosHaveNotes$ | async) {
    <div class="d-flex mb-3 overflow-auto">
      <button class="btn btn-toggle" [class.active]="settings.notesVisible" (click)="toggleNotes(settings)">
        {{ 'mydepot.depotoverview.positions.settings.notes' | transloco }}
      </button>
    </div>
  }
}

<shared-micar-contracts-nudging class="d-block mb-3" />

@if (showPositions) {
  <ng-container *ngTemplateOutlet="table; context: { items: positions, sumItems: sums }" />
}

<ng-template #table let-items="items" let-sumItems="sumItems">
  <table
    aria-describedby="positions"
    class="table-depot table-positions opacity-container"
    [class.active]="isPotentialCustomer || items"
    [class.light-opacity]="currentlyEditingEntryQuote"
    @onlyEnter
  >
    <tbody>
      <tr>
        <th colspan="2">
          <web-components-sorter-label
            [sorter]="sorter"
            attr="longName"
            label="mydepot.depotoverview.positions.labels.assetName"
            direction="after"
            (click)="sortBy('longName')"
          />
          <br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="shortName"
            label="mydepot.depotoverview.crypto-wallet.labels.symbol"
            direction="after"
            (click)="sortBy('shortName')"
          />
        </th>
        @if (!currentlyEditingEntryQuote) {
          <th>
            <web-components-sorter-label
              [sorter]="sorter"
              attr="quantity"
              label="mydepot.depotoverview.positions.labels.quantity"
              direction="before"
              (click)="sortBy('quantity')"
            />
            <br />
            {{ 'mydepot.depotoverview.positions.labels.availableQuantity' | transloco }}
          </th>
        }
        <th class="ignore-opacity">
          {{ 'mydepot.depotoverview.positions.labels.avgEntryQuote' | transloco }}<br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="entryValue"
            label="mydepot.depotoverview.positions.labels.entryValue"
            direction="before"
            (click)="sortBy('entryValue')"
          />
        </th>
        <th>
          {{ 'mydepot.depotoverview.positions.labels.quote' | transloco }}<br />
          <web-components-sorter-label
            [sorter]="sorter"
            attr="currentValue"
            label="mydepot.depotoverview.positions.labels.currentValue"
            direction="before"
            (click)="sortBy('currentValue')"
          />
        </th>
        <th>
          <web-components-sorter-label
            [sorter]="sorter"
            attr="perfTodayPct"
            label="mydepot.depotoverview.positions.labels.perfTodayPct"
            direction="before"
            (click)="sortBy('perfTodayPct')"
          />
          <br />
          {{ 'mydepot.depotoverview.positions.labels.perfTodayAbs' | transloco }}
        </th>
        <th>
          <web-components-sorter-label
            [sorter]="sorter"
            attr="perfPct"
            label="mydepot.depotoverview.positions.labels.perfPct"
            direction="before"
            (click)="sortBy('perfPct')"
          />
          <br />
          {{ 'mydepot.depotoverview.positions.labels.perfAbs' | transloco }}
        </th>
        <th>
          {{ 'mydepot.depotoverview.positions.labels.quoteTime' | transloco }}<br />
          {{ 'mydepot.depotoverview.positions.labels.quoteDate' | transloco }}
        </th>
        @if (actionsEnabled && !currentlyEditingEntryQuote) {
          <th></th>
        }
      </tr>
      @for (item of items; track item.id) {
        <tr
          zero-crypto
          [class.no-border]="currentlyEditingNote?.isin === item.isin || ((cryptoSettings$ | async)?.notesVisible && item.note?.note)"
          [item]="item"
          [actionsEnabled]="actionsEnabled"
          [isEditEntryQuoteMode]="currentlyEditingEntryQuote !== undefined"
          [isCurrentlyEditing]="currentlyEditingEntryQuote === item.isin"
          (editNote)="editNote(item.isin, item.note?.note)"
          (editEntryQuote)="editEntryQuote(item.isin)"
          (updateEntryQuote)="updateEntryQuote($event)"
        ></tr>
        @if (cryptoSettings$ | async; as settings) {
          @if (currentlyEditingNote?.isin === item.isin) {
            <tr>
              <td colspan="9">
                <div class="d-flex">
                  <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                  <div class="width-100">
                    <textarea
                      #noteTextArea
                      class="width-100"
                      maxlength="185"
                      [(ngModel)]="currentlyEditingNote.note"
                      (blur)="onSubmitNote(currentlyEditingNote.note, item.isin, settings)"
                    ></textarea>
                    <div>{{ 'mydepot.depotoverview.positions.note-label' | transloco }}</div>
                  </div>
                </div>
              </td>
            </tr>
          } @else {
            @if (settings.notesVisible && item.note?.note) {
              <tr>
                <td colspan="9">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                    <div class="width-100 note" [innerHTML]="item.note.note | noteSafeHtml"></div>
                  </div>
                </td>
              </tr>
            }
          }
          <ng-template #note>
            @if (settings.notesVisible && item.note?.note) {
              <tr>
                <td colspan="9">
                  <div class="d-flex align-items-center">
                    <div class="mr-2">{{ 'watchlist.note' | transloco }}</div>
                    <div class="width-100 note" [innerHTML]="item.note.note | noteSafeHtml"></div>
                  </div>
                </td>
              </tr>
            }
          </ng-template>
        }
      }
      @if (customerStateFacade.customerBaseData$ | async; as customerBaseData) {
        @if ((isPotentialCustomer || !positions?.length) && customerBaseData?.hasActiveWallet) {
          <tr>
            <td colspan="9" class="text-center align-middle border-0">
              <p class="pb-2 pt-2">{{ 'mydepot.depotoverview.crypto-wallet.empty' | transloco }}</p>
              <div class="d-flex justify-content-center">
                <web-design-system-button [routerLink]="commonRoutes.postlogin.crypto">
                  {{ 'mydepot.depotoverview.crypto-wallet.crypto_button' | transloco | uppercase }}
                </web-design-system-button>
              </div>
            </td>
          </tr>
        }
        @if (!customerBaseData?.hasActiveWallet) {
          <tr>
            <td colspan="8" class="text-center align-middle border-0">
              <p class="pb-2 pt-2" [innerHtml]="'mydepot.depotoverview.crypto-wallet.openWallet' | transloco"></p>
              <div class="d-flex justify-content-center align-items-center">
                <web-design-system-button size="small" class="ml-0 ml-sm-1" [routerLink]="commonRoutes.postlogin.kryptoOnboarding">
                  {{ 'mydepot.depotoverview.crypto-wallet.openWalletButton' | transloco }}
                </web-design-system-button>
              </div>
            </td>
          </tr>
        }
      }

      @if (positions?.length) {
        @for (sum of sumItems; track $index) {
          <tr class="top-align">
            <td colspan="2">
              <div class="font-bold text-uppercase">
                {{ 'mydepot.depotoverview.positions.sum.label' | transloco }}
                @if (sum.type !== 'ALL') {
                  {{ 'position-filter.' + sum.type | transloco }}
                }
              </div>
            </td>
            <td class="hidden-xs hidden-sm"></td>
            <td>
              <div class="d-flex text-color-primary justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                  {{ 'mydepot.depotoverview.positions.sum.entryValue' | transloco }}
                </div>
                <div class="text-color-primary">
                  {{ sum.entryValue | currency }}
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex text-color-primary justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                  {{ 'mydepot.depotoverview.positions.sum.currentValue' | transloco }}
                </div>
                <div class="text-color-primary">
                  {{ sum.currentValue | currency }}
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex text-color-primary justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                  {{ 'mydepot.depotoverview.positions.sum.perfTodayPct' | transloco }}
                </div>
                <div
                  [class.text-color-success]="sum.perfTodayAbs >= 0"
                  [class.text-color-error]="sum.perfTodayAbs < 0"
                  zeroBlink
                  [val]="sum.perfTodayAbs"
                >
                  {{ sum.perfTodayPct | number: '1.2-2' }}&nbsp;%
                </div>
              </div>
              <div class="d-flex text-color-primary justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow"></div>
                <div [class.text-color-success]="sum.perfTodayAbs >= 0" [class.text-color-error]="sum.perfTodayAbs < 0">
                  {{ sum.perfTodayAbs | currency }}
                </div>
              </div>
            </td>
            <td>
              <div class="d-flex text-color-primary justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow">
                  {{ 'mydepot.depotoverview.positions.sum.perfPct' | transloco }}
                </div>
                <div [class.text-color-success]="sum.perfAbs >= 0" [class.text-color-error]="sum.perfAbs < 0" zeroBlink [val]="sum.perfAbs">
                  {{ sum.perfPct | number: '1.2-2' }}&nbsp;%
                </div>
              </div>
              <div class="d-flex text-color-primary justify-content-end">
                <div class="hidden-lg hidden-xl flex-xs-grow flex-sm-grow flex-md-grow"></div>
                <div [class.text-color-success]="sum.perfAbs >= 0" [class.text-color-error]="sum.perfAbs < 0">
                  {{ sum.perfAbs | currency }}
                </div>
              </div>
            </td>
            <td class="margin-xs-bottom-15 margin-sm-bottom-15 hidden-xs hidden-sm"></td>
            @if (actionsEnabled) {
              <td></td>
            }
          </tr>
        }
      }
    </tbody>
  </table>
</ng-template>
